import type { AccountCase } from './types';

// Made-up cases so the list can be reviewed before svc-contracting serves them. Delete with the API wiring.
export const SAMPLE_ACCOUNT_CASES: ReadonlyArray<AccountCase> = [
  {
    id: 'sample-case-1',
    caseNumber: '03571204',
    contactName: 'Alex Example',
    subject: 'Rate plan missing from the extranet',
    priority: 'High',
    createdDate: '2026-10-08T02:14:00.000Z',
    status: 'New',
  },
  {
    id: 'sample-case-2',
    caseNumber: '03570987',
    contactName: 'Blair Sample',
    subject: 'Update bank details for payments',
    priority: 'Medium',
    createdDate: '2026-09-29T05:41:00.000Z',
    status: 'New',
  },
  {
    id: 'sample-case-3',
    caseNumber: '03569512',
    contactName: 'Casey Placeholder',
    subject: 'Guest arrived with no booking on file',
    priority: 'High',
    createdDate: '2026-09-12T11:03:00.000Z',
    status: 'Closed - Resolved (Partner)',
  },
  {
    id: 'sample-case-4',
    caseNumber: '03568142',
    contactName: 'Alex Example',
    subject: 'Blackout dates for the New Year period',
    priority: 'Low',
    createdDate: '2026-08-20T23:30:00.000Z',
    status: 'Closed - Resolved (Partner)',
  },
  {
    id: 'sample-case-5',
    caseNumber: '03566330',
    contactName: null,
    subject: 'Extranet login reset',
    priority: 'Low',
    createdDate: '2026-07-04T01:12:00.000Z',
    status: 'Closed - Duplicate',
  },
  {
    id: 'sample-case-6',
    caseNumber: '03561877',
    contactName: 'Blair Sample',
    subject: 'Room type photos out of date',
    priority: 'Medium',
    createdDate: '2026-05-18T07:55:00.000Z',
    status: 'Closed - Resolved (Partner)',
  },
  {
    id: 'sample-case-7',
    caseNumber: '03554019',
    contactName: 'Casey Placeholder',
    subject: 'Invoice query for the March campaign',
    priority: null,
    createdDate: '2026-03-02T22:48:00.000Z',
    status: 'Closed - Resolved (Partner)',
  },
];
